// Utilitários e constantes compartilhados entre os sub-componentes de NegocioDetalhe.
import type React from 'react';
import { fmtDataBr as _fmtDataBr } from '../../utils/dataFmt';

export const STATUS_LABELS: Record<string, string> = {
  prospeccao: 'Aguardando 1º Contato',
  qualificacao: 'Identificação de Necessidades',
  proposta: 'Proposta',
  follow_up: 'Follow-up',
  negociacao: 'Negociação',
  ganho: 'Fechamento',
  perdido: 'Perdido',
  cancelado: 'Cancelado',
};

export const STATUS_ETAPAS = ['prospeccao', 'qualificacao', 'proposta', 'follow_up', 'negociacao', 'ganho'];

// Canal da interação registrada na linha do tempo (01/10/2026). Os CRMs de
// referência separam ligação, e-mail e reunião porque "quando falamos com o
// cliente pela última vez" é a pergunta que mais se faz a um negócio. O evento
// continua sendo `tipo: 'nota'` — o canal viaja no `meta`, que já era livre —,
// então nada que lê `nota` hoje muda de comportamento.
export const CANAIS_INTERACAO: { chave: string; rotulo: string; emoji: string; dica: string }[] = [
  { chave: 'nota',     rotulo: 'Nota',     emoji: '💬', dica: 'Registrar interação, ligação, e-mail, observação…' },
  { chave: 'ligacao',  rotulo: 'Ligação',  emoji: '📞', dica: 'Com quem falou e o que ficou combinado?' },
  { chave: 'email',    rotulo: 'E-mail',   emoji: '✉️', dica: 'O que foi enviado ou respondido?' },
  { chave: 'reuniao',  rotulo: 'Reunião',  emoji: '🤝', dica: 'Quem participou e quais foram os encaminhamentos?' },
  { chave: 'whatsapp', rotulo: 'WhatsApp', emoji: '🟢', dica: 'O que foi conversado?' },
];

/** O `meta` do evento chega como objeto (jsonb) ou, em rota antiga, como texto. */
export function metaDoEvento(evento: any): any {
  const m = evento?.meta;
  if (!m) return null;
  if (typeof m === 'string') { try { return JSON.parse(m); } catch { return null; } }
  return m;
}

// Cores Hydrodata
export const HD_BLUE = '#0930D0';
export const HD_BLUE_DEEP = '#020D7F';
export const HD_BLUE_LIGHT = '#5B7FFF';

export const ICONES_TIPO: Record<string, string> = {
  pdf: '📄', kmz: '🗺️', kml: '🗺️', image: '🖼️', doc: '📝',
  sheet: '📊', archive: '🗜️', other: '📎',
};

export const fmt = (v: any) => {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return 'R$ ' + (Number.isFinite(n) ? n : 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};
export const fmtDate = _fmtDataBr;
export const fmtDateTime = (s: any) => s ? new Date(s).toLocaleString('pt-BR') : '—';

export function fmtBytes(b: number | null): string {
  if (!b) return '—';
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1024 / 1024).toFixed(1)} MB`;
}

// Estilos compartilhados
export const inp: React.CSSProperties = {
  width: '100%', padding: '7px 10px', fontSize: 12, borderRadius: 5,
  border: '0.5px solid #ddd', boxSizing: 'border-box',
};
export const btnSec: React.CSSProperties = {
  padding: '7px 16px', fontSize: 12, marginTop: 12, border: '0.5px solid #ddd',
  borderRadius: 5, background: '#fff', cursor: 'pointer',
};
export const modalOverlayLocal: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000,
};
export const modalContentLocal: React.CSSProperties = {
  background: '#fff', borderRadius: 10, padding: 22, width: '92%', maxHeight: '90vh', overflow: 'auto',
};
export const btnSecLocal: React.CSSProperties = {
  padding: '8px 18px', fontSize: 12, border: '1px solid #ddd', borderRadius: 5, background: '#fff', cursor: 'pointer',
};
export const btnPriLocal: React.CSSProperties = {
  padding: '8px 22px', fontSize: 12, border: 'none', borderRadius: 5, background: '#0930D0', color: '#fff', cursor: 'pointer', fontWeight: 600,
};
